import React, { FC } from 'react';
import { ThemedLayoutV2 } from '@refinedev/mui';
import { Outlet } from 'react-router-dom';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { ErrorBoundary as TranslatedErrorBoundary } from '@/shared/components/ui';

type AuthenticatedLayoutProps = {
  Header: FC; // Changed from React.ComponentType<any>
};

export const AuthenticatedLayout: FC<AuthenticatedLayoutProps> = ({
  Header,
}) => {
  return (
    <ThemedLayoutV2
      Header={Header}
      Title={({ collapsed }: { collapsed: boolean }) => (
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            py: 1,
            pl: collapsed ? 0 : 0.5,
            pr: collapsed ? 0 : 1,
            justifyContent: collapsed ? 'center' : 'flex-start',
          }}
        >
          <Box
            component="img"
            src="/ema-adaptive-icon.png"
            alt="EMA Compare Logo"
            sx={{
              width: 96,
              height: 96,
              flexShrink: 0,
              objectFit: 'contain',
              ml: collapsed ? 0 : -1,
              mr: collapsed ? 0 : 1,
            }}
          />
          {!collapsed && (
            <Typography
              variant="h6"
              fontWeight={700}
              color="text.primary"
              fontSize="0.9rem"
              sx={{
                lineHeight: 1.2,
                mr: 2,
              }}
            >
              EMA Compare
            </Typography>
          )}
        </Box>
      )}
    >
      <TranslatedErrorBoundary>
        <Outlet />
      </TranslatedErrorBoundary>
    </ThemedLayoutV2>
  );
};
